import { hexToRgb } from '../../common/hexToRgb';
import { updateColor } from '../../js/colorHandling';

export function useColorFuncs(swiperRef) {
  const handleClick = (item, index) => () => {
    swiperRef?.slideToLoop(index, 500);
    const temp = hexToRgb(item);
    updateColor(temp);
    // onClick(item.fcID);
  };

  return { handleClick };
}
